import Task from '../../types/Task';
import { TaskType } from '../../types/TaskType';

/**
 * Which space a new item is created in.
 *
 * A subitem always belongs to its parent's space. Deriving it from the persisted
 * "current space" store instead is what let an All Tasks row from space B create a
 * child in space A, which no table can then render. (#2884)
 */
export const resolveCreateSpaceId = (args: {
  showSpaceSelector?: boolean;
  selectedSpaceId: number | null;
  actualSpaceId: string | number | null;
  parentSpaceId?: number | null;
}): number => {
  const { showSpaceSelector, selectedSpaceId, actualSpaceId, parentSpaceId } = args;

  if (parentSpaceId != null) return Number(parentSpaceId);
  if (showSpaceSelector) return selectedSpaceId ?? 0;
  return Number(actualSpaceId);
};

/** Modal props for the "add subitem" affordance on a task/epic row. */
export const buildAddSubitemModalProps = (task: Task) =>
  task?.type === TaskType.epic
    ? { epicId: task.id, parentSpaceId: task.workspaceId }
    : { parentTask: task, parentSpaceId: task.workspaceId };
